var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app__text" },
    [
      _c("div", {
        staticClass: "app__diamond app__diamond--top app__diamond--green"
      }),
      _vm._v(" "),
      _c("Close"),
      _vm._v(" "),
      _c("div", { staticClass: "app__textWrapper" }, [
        _c("div", {
          staticClass: "app__textContent",
          domProps: { innerHTML: _vm._s(_vm.step.content) }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "app__textButton" }, [
          _c(
            "button",
            {
              staticClass: "btn btn__primary w-100",
              on: {
                click: function($event) {
                  return _vm.nextStep()
                }
              }
            },
            [_vm._v(_vm._s(_vm.step.button))]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "app__diamond app__diamond--bottom app__diamond--red"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }